import script from "./Products.vue?vue&type=script&setup=true&lang=js"
export * from "./Products.vue?vue&type=script&setup=true&lang=js"

import "./Products.vue?vue&type=style&index=0&id=361798d7&lang=scss"

const __exports__ = script;

export default __exports__